export const SSL_PORT = 443;
export const DEFAULT_PORT = 80;

export function createUrlExpander(host: string, port: string | undefined, options?: { ssl: boolean }) {
  port = port || (options?.ssl ? SSL_PORT.toString() : DEFAULT_PORT.toString());
  const urlBase = (options?.ssl ? 'https://' : 'http://') + host;
  return new UrlExpander(urlBase, port);
}
function shouldExcludePort(excludePortIfSSL: boolean, port: string | undefined) {
  return excludePortIfSSL && port === SSL_PORT.toString();
}
export class UrlExpander {
  constructor(
    private urlBase: string,
    private port: string | undefined
  ) {}

  expand(path: string, opts?: { excludeSSLPort: boolean }) {
    let url = this.urlBase;
    // dont include ssl port if option is present
    if (typeof this.port !== 'undefined' && !shouldExcludePort(!!opts?.excludeSSLPort, this.port)) {
      url += ':' + this.port;
    }
    return url + path;
  }
}
